import { Controller } from "stimulus";
import Sortable from "sortablejs";

/**
 * Reorders items via SortableJS (mouse, touch, and pointer input all supported natively).
 *
 * Mark each sortable row with `data-sortable-item`. By default only a drag started on an
 * element carrying `data-drag-handle` initiates sorting. Set the `wholeRowDraggable` value
 * to allow starting a drag from anywhere in the row instead (matching the legacy
 * reorderable-list controller's behavior) — in that mode, links/buttons/inputs are excluded
 * from initiating a drag so their normal click/focus behavior keeps working.
 */
export default class SortableListController extends Controller {
  static values = {
    submitOnReorder: Boolean,
    wholeRowDraggable: Boolean,
  };

  connect() {
    this.sortable = Sortable.create(this.element, {
      handle: this.wholeRowDraggableValue ? undefined : "[data-drag-handle]",
      filter: this.wholeRowDraggableValue ? "a, button, input, select, textarea" : undefined,
      preventOnFilter: false,
      draggable: "[data-sortable-item]",
      animation: 150,
      ghostClass: "opacity-30",
      chosenClass: "shadow-lg",
      dragClass: "shadow-lg",
      delayOnTouchOnly: true,
      delay: 50,
      touchStartThreshold: 5,
      onEnd: this.handleEnd.bind(this),
    });

    this.disableDrag = this.disableDrag.bind(this);
    this.enableDrag = this.enableDrag.bind(this);
    this.element.querySelectorAll("trix-editor, input").forEach((editor) => {
      editor.addEventListener("focus", this.disableDrag);
      editor.addEventListener("blur", this.enableDrag);
    });
  }

  disconnect() {
    this.sortable?.destroy();
    this.sortable = null;
  }

  disableDrag() { this.sortable?.option("disabled", true); }
  enableDrag() { this.sortable?.option("disabled", false); }

  handleEnd(event) {
    const { item, oldDraggableIndex, newDraggableIndex } = event;
    if (this.submitOnReorderValue) this.element.closest("form")?.requestSubmit();
    this.dispatch("reordered", { detail: { id: item.id, fromIndex: oldDraggableIndex, toIndex: newDraggableIndex } });
  }
}
